

async function loadCurrencyData() {
  try {
    const response = await fetch('/assets/Common-Currency.json');
    return await response.json();
  } catch (error) {
    console.error('Error loading currency data:', error);
    return {};
  }
}

export function roundFixed(n, prec) {
  var k = Math.pow(10, prec);
  return Math.round(n * k) / k;
}


export function floorFixed(n, prec) {
  var k = Math.pow(10, prec);
  return Math.floor(Math.round(n * k * 10) / 10) / k;
}

export function numberFormat(number, decimals, dec_point, thousands_sep) {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep;
  const dec = (typeof dec_point === 'undefined') ? '.' : dec_point;

  const toFixedFix = function (n, prec) {
    return '' + floorFixed(n, prec);
  };

  let s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }

  return s.join(dec);
}


export function amountToInt(amount, decimalSeparator = '.', thousandsSeparator = '') {
  amount = amount.toString();
  if (thousandsSeparator) {
    const regex = new RegExp(escapeRegExp(thousandsSeparator), 'g');
    amount = amount.replace(regex, '');
  }

  if (decimalSeparator !== '.') {
    const regex = new RegExp(escapeRegExp(decimalSeparator), 'g');
    amount = amount.replace(regex, '.');
  }

  amount = amount.replace(/[^0-9.\-+]/g, '');

  return parseFloat(amount);
}


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}


export function roundToNextDecimal(n, precision) {
  const factor = Math.pow(10, precision);
  return Math.ceil(n * factor) / factor;
}

export function roundToNextMultipleOf05(n) {
  return Math.ceil(n / 0.05) * 0.05;
}

export function formatAmount(amount, decimals = 0, store = {}, currentLanguage = null) {
  
  if (typeof amount === 'string') {
    amount = amountToInt(
      amount,
      store.priceDecimalSeparator || '.',
      store.priceThousandsSeparator || ''
    );
  }
  
  amount = roundToNextMultipleOf05(amount);
  
  const formattedAmount = numberFormat(
    amount,
    decimals,
    store.priceDecimalSeparator || '.',
    store.priceThousandsSeparator !== null ? store.priceThousandsSeparator : ''
  );
  
  const currencyCode = store.devise || 'EUR';
  const currencyData = store.currencyData || {};
 const symbol = store.currencyData && store.currencyData[currencyCode] 
    ? store.currencyData[currencyCode].symbol 
    : '€';

  const currencyPosition = currentLanguage?.currencyPosition || store.currencyPosition || '11';
  
  switch (currencyPosition) {
    case '00': return `${symbol}${formattedAmount}`;
    case '01': return `${symbol} ${formattedAmount}`;
    case '10': return `${formattedAmount}${symbol}`;
    case '11': return `${formattedAmount} ${symbol}`;
    default: return `${formattedAmount} ${symbol}`;
  }
}




export default {
  formatAmount,
  numberFormat,
  amountToInt,
  loadCurrencyData
};